<template>
  <!-- A printed sheet leaves the app behind, so it has to say on its own face who ran
       what, when, and what is not on it. Firms file these outside LeanLaw.
       print-only, not `hidden print:block`: a legacy global `.hidden` sets
       visibility:hidden, which printed this as a blank gap. -->
  <div
    class="print-only mb-4 border-b-2 border-black pb-2"
    data-cy="conflict-print-masthead"
  >
    <div class="text-lg font-bold">{{ sheet.firmName }}</div>
    <div class="mt-0.5 text-xs text-gray-700">
      Conflict check from LeanLaw ·
      {{ sheet.saved ? 'Saved in LeanLaw' : 'Not saved in LeanLaw' }}
    </div>
    <div class="text-xs text-gray-700" data-cy="conflict-print-run">
      Run by {{ sheet.runByName || 'an unknown user' }}
      <template v-if="runAt">on {{ runAt }}</template>
    </div>
    <div class="mt-1 text-xs text-gray-700 [overflow-wrap:anywhere]">
      Searched for: {{ sheet.queryText }}
    </div>
    <div class="text-xs text-gray-700 [overflow-wrap:anywhere]">
      {{ sheet.parties.length }}
      {{ sheet.parties.length === 1 ? 'name' : 'names' }} checked:
      {{ sheet.parties.join(' · ') }}
    </div>
    <div class="text-xs text-gray-700">
      {{
        sheet.includedTimeEntries
          ? 'Time entries included.'
          : 'Time entries not searched.'
      }}
      Invoice narratives are not searched.
    </div>
    <div v-if="sheet.hiddenRowCount" class="text-xs font-bold">
      {{ sheet.hiddenRowCount }} result{{
        sheet.hiddenRowCount === 1 ? '' : 's'
      }}
      hidden by the field filter and not printed.
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { formatRunAt } from '../utils/conflictDateHelpers';
import type { ConflictPrintSheet } from '../models/conflictTypes';

const props = defineProps<{ sheet: ConflictPrintSheet }>();

const runAt = computed(() => formatRunAt(props.sheet.runAt));
</script>
